import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { ECreditRecordType } from '@/store/api/Stripe/Stripe.types'

import type { IHistoryPlanItem } from './HistoryPlanItem.type'

export const HistoryPlanItem = ({ data }: IHistoryPlanItem) => {
  const { t } = useTranslation()

  const getTransactionType = (recordType: ECreditRecordType) => {
    switch (recordType) {
      case ECreditRecordType.ACCREDITATION:
        return t('dashboard.reports.added')
      case ECreditRecordType.REFOUND:
        return t('dashboard.reports.refund')
      case ECreditRecordType.BURNED:
        return t('dashboard.reports.used')
      case ECreditRecordType.DISCOUNT:
        return t('dashboard.reports.discount')
      case ECreditRecordType.EXPIRATION:
        return t('dashboard.reports.expiration')
    }
  }

  return (
    <div className="bg-baseColorHighlight rounded-md flex justify-between px-6 py-3  mb-5 items-center">
      <div className="flex flex-col gap-2">
        <p className="font-small text-sm">
          {getTransactionType(data.recordType)}
        </p>
        <p className="text-neutralColor80 text-sm font-light tracking-wider">
          {format(new Date(data.date), 'MM/dd/yyyy')}
        </p>
      </div>

      <div className="flex  md:min-w-52">
        <h1 className="text-neutralColor text-base font-medium tracking-tight hidden md:flex">
          {t('dashboard.billingAndInvoices.creditsLabel')}
        </h1>
      </div>

      <div className="flex flex-row items-center">
        {(data.recordType === ECreditRecordType.ACCREDITATION ||
          data.recordType === ECreditRecordType.REFOUND) && (
          <p className="text-dynamicGreen">{`+${data.quantity}`}</p>
        )}
        {(data.recordType === ECreditRecordType.BURNED ||
          data.recordType === ECreditRecordType.EXPIRATION) && (
          <p className="text-dynamicRed">{`${data.quantity}`}</p>
        )}
        {data.recordType === ECreditRecordType.DISCOUNT && (
          <p className="text-dynamicRed">{`${data.quantity}`}</p>
        )}
      </div>
    </div>
  )
}
